import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import PropTypes from 'prop-types';
import {
    selectIsNative,
    selectPreferences,
} from 'yoda-site-components/lib/selectors/ContextSelector';
import Icon from 'yoda-core-components/lib/components/Icon/Icon';
import { dt } from 'yoda-core-components/lib/helpers/Utils/GetTailwindToken';
import Button from 'yoda-core-components/lib/components/Button';
import { appSignIn } from 'yoda-site-components/lib/actions/NativeAppAction';
import { openRewardsPromotionLogin } from 'yoda-site-components/lib/actions/SignInSliderActions';
import FSHRedTruck from 'yoda-site-components/lib/assets/svg/fsh-red-truck.svg';
import { triggerModulePageTracking } from 'yoda-site-components/lib/actions/AnalyticsAction';
import { RELOAD_LOCATION } from 'yoda-site-components/lib/actionTypes/SigninActionTypes';
import { enableFeatureInApp } from 'yoda-site-components/lib/helpers/Utils/features';

function FreeShippingThreshold(props) {
    const { renderFrom, closeInterstitial, wrapperStyles } = props;
    /** if cartSignIn render Signin Text instead of buttion
     *  if AtcSlider close slider and open signinslider
     */
    const fromCartSignIn = renderFrom === 'cartSignIn';
    const fromATCSlider = renderFrom === 'ATCSlider';
    const fromCartOrderSummary = renderFrom === 'cartOrderSummary';
    const fromPDP = renderFrom === 'PDP';
    const dispatch = useDispatch();
    const isNative = useSelector((state) => selectIsNative(state));
    const isAndroid = useSelector((state) => state.context?.isNativeAndroid ?? false);
    const irisRewardCustomerThreshold = useSelector(
        (state) => state?.irisPromotionalBannerData?.shippingThresholds?.rewardCustomer
    );
    const preferences = useSelector((state) => selectPreferences(state));
    const configRewardCustomerThreshold = preferences?.shippingThresholds?.rewardCustomer;
    const rewardCustomerThreshold =
        irisRewardCustomerThreshold || configRewardCustomerThreshold || '$49';
    const postSignInRefreshMinVersion =
        preferences?.FSHPostSignInRefreshMinVersion?.androidMinVersion || '';

    const handleSignIn = () => {
        if (fromATCSlider) closeInterstitial();
        dispatch(
            triggerModulePageTracking({
                name: `${fromATCSlider ? 'fsh-atc' : 'fsh'} : signin`,
                linktext: 'sign in',
            })
        );
        if (isNative) {
            const enableRefreshforAndroid = enableFeatureInApp({
                iosMinVersion: '',
                androidMinVersion: postSignInRefreshMinVersion,
            });
            /** Refresh from web for Android happens twice, ios has auto refresh by default */
            const refreshfromWeborApp = enableRefreshforAndroid
                ? 'WEB_REFRESH_SIGN_IN_REQUEST'
                : RELOAD_LOCATION;
            const returnActionAppSignin =
                (fromPDP || fromCartOrderSummary || fromATCSlider) && isAndroid
                    ? refreshfromWeborApp
                    : '';
            dispatch(appSignIn(returnActionAppSignin));
        } else dispatch(openRewardsPromotionLogin());
    };
    const wrapperClass = dt([fromCartSignIn ? 'mb-4' : '']);
    return (
        <div className={`${wrapperClass} ${wrapperStyles}`}>
            <Icon
                iconType="svg"
                automationId="fshRedTruckIcon"
                className={
                    fromCartSignIn ? dt(['ml-2', 'mr-2']) : dt([fromPDP ? 'px-[3px]' : 'px-1'])
                }
                width={fromCartSignIn ? '40' : '32'}
                height={fromCartSignIn ? '40' : '32'}
                viewBox={fromCartSignIn ? '0 0 50 50' : '0 0 32 32'}
            >
                <FSHRedTruck />
            </Icon>
            <div className={dt([fromPDP ? 'ml-1.5' : 'inline'])}>
                {!fromCartSignIn && (
                    <Button
                        buttonType="Link"
                        size="Sm"
                        className={dt([fromPDP ? '!inline' : 'ml-1.5'])}
                        automationId="fsh-signin"
                        onClick={handleSignIn}
                    >
                        Sign in{` `}
                    </Button>
                )}
                <div
                    className={
                        fromCartSignIn
                            ? dt(['text-medium', 'mr-2', 'ml-1.5', 'inline-block'])
                            : dt(['text-small', 'inline-block', fromPDP ? 'inline' : 'ml-1'])
                    }
                >
                    {fromCartSignIn
                        ? `Sign in for FREE Shipping on ${rewardCustomerThreshold}+`
                        : ` for FREE Shipping on ${rewardCustomerThreshold}+`}
                </div>
            </div>
        </div>
    );
}

FreeShippingThreshold.propTypes = {
    renderFrom: PropTypes.string,
    closeInterstitial: PropTypes.func,
};
FreeShippingThreshold.defaultProps = {
    renderFrom: '',
    closeInterstitial: () => {},
};

export default FreeShippingThreshold;
